import React, { Component } from 'react';
import { connect } from 'react-redux';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { errorHandler, getContent } from '../../util/responseUtil';
import API_MASTER_DATA from '../../api/apiMasterData';
import ActionType from '../../redux/reducer/globalActionType';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';

class MasterDataRolePermission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permission: [],
            activeMenu: [],
            selectedPermission: {}
        }
    }

    getListPermission = () => {
        API_MASTER_DATA.getListPermission(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        permission: getContent(res)
                    })
                    if (this.props.action !== "add") {
                        this.setState({
                            selectedPermission: this.props.permission
                        })
                    }
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    formatStringMenu = (str) => {
        return str
            .split("_")
            .map(word => word[0].toUpperCase() + word.slice(1))
            .join(" ");
    }

    handleToggleCollapse = menu => {
        if (this.handleMatchMenu(menu)) {
            let filterData = this.state.activeMenu.filter(currentMenu => currentMenu !== menu);
            return this.setState({
                activeMenu: [
                    ...filterData
                ]
            })
        }
        this.setState({
            activeMenu: [
                ...this.state.activeMenu,
                menu
            ]
        })
    }

    handleMatchMenu = menu => {
        return this.state.activeMenu.includes(menu);
    }

    handleCheckbox = (e, permission, data) => {
        const isChecked = e.target.checked;
        const key = permission.permission;
        const action = data.action;

        if (isChecked) {
            if (this.state.selectedPermission[key]) {
                this.setState({
                    selectedPermission: {
                        ...this.state.selectedPermission,
                        [key]: [...this.state.selectedPermission[key], action],
                    }
                })
                return;
            }
            this.setState({
                selectedPermission: {
                    ...this.state.selectedPermission,
                    [key]: [action],
                }
            })
            return;
        }

        let tempData = this.state.selectedPermission[key];
        tempData = tempData.filter(tempAction => tempAction !== action);
        if (tempData.length === 0) {
            delete this.state.selectedPermission[key];
            this.setState({
                selectedPermission: {
                    ...this.state.selectedPermission
                }
            })
            return;
        }
        this.setState({
            selectedPermission: {
                ...this.state.selectedPermission,
                [key]: [...this.state.selectedPermission[key].filter(tempAction => tempAction !== action)]
            }
        })
    }

    handleChecked = (permission, action) => {
        if (!this.state.selectedPermission[permission]) return false;
        return this.state.selectedPermission[permission].includes(action);
    }

    formatStringAction = (str) => {
        return str
            .split("-")
            .map(word => word[0].toUpperCase() + word.slice(1))
            .join(" ");
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListPermission();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.permission !== this.props.permission) {
            this.setState({
                selectedPermission: this.props.permission
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    renderPermission(permissions) {
        return (
            <>
                {permissions.map((permission, index) => (
                    <div key={index} className={permission.id !== 0 ? "bg-white rounded shadow-box-button border border-gray-100 p-5 my-5" : "bg-white rounded shadow-box-button border border-gray-100 p-5 mb-5"}>
                        <div className={permission.children.length > 0 ? "flex justify-between items-center text-lg font-medium cursor-pointer select-none" : "flex justify-between items-center text-lg font-medium select-none"} onClick={() => this.handleToggleCollapse(permission.menu)}>
                            <div>{this.formatStringMenu(permission.menu)}</div>
                            {permission.children.length > 0 && <FontAwesomeIcon icon={this.handleMatchMenu(permission.menu) ? faAngleUp : faAngleDown} />}
                        </div>
                        <div className="flex">
                            {permission.actions.map((action, index) =>
                                <div className="flex items-center mr-5" key={index}>
                                    <input id={permission.menu + index} type="checkbox" className="mr-1" checked={this.handleChecked(permission.permission, action.action)} onChange={e => this.handleCheckbox(e, permission, action)} disabled={this.props.action === "detail"} />
                                    <label htmlFor={permission.menu + index} className="select-none">{this.formatStringAction(action.action)}</label>
                                </div>
                            )}
                        </div>
                        <div className={this.handleMatchMenu(permission.menu) ? "block" : "hidden"}>
                            {permission.children && this.renderPermission(permission.children)}
                        </div>
                    </div>
                ))}
            </>
        );
    }

    render() {
        return (
            <div className="h-full pb-5 space-y-3">
                <BreadCrumbs
                    parentMenu="Pengaturan"
                    serviceMenu="Role"
                    menuItem="Izin Pengaturan"
                    title="Izin Pengaturan"
                    handleBack={() => this.props.handleTogglePermission()}
                />
                <div className="h-content">
                    <div className="w-full h-full overflow-auto p-1 relative">
                        <div className={this.state.permission.length > 0 ? "mb-14" : "hidden"}>{this.renderPermission(this.state.permission)}</div>
                        <div className="flex justify-between absolute right-1 bottom-1">
                            <div className={this.state.permission.length > 0 ? "block" : "hidden"}>
                                <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3" onClick={() => this.props.handleTogglePermission()}>Batal</button>
                                <button type="button" id="btnsave" className={this.props.action === "detail" ? "hidden" : "bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-4"} onClick={() => this.props.handleCheckbox(this.state.selectedPermission)}>Simpan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MasterDataRolePermission);